// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import i18n from './locales'
import App from './App'
import router from './router'
import {post,get,patch,put,file} from './common/http'
import path from './common/config'
import iView from 'iview';
import 'iview/dist/styles/iview.css';    // 使用 CSS

Vue.use(iView,{
  i18n: (key, value) => i18n.t(key, value)
});

//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$get=get;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
Vue.prototype.$file=file;
Vue.prototype.$ht_ip = path.ip;//全局后台接口ip
Vue.prototype.$path=path;
Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js